export default __webpack_public_path__ + "static/media/www.a6b6499f.svg";